import React from 'react';
import TilesComponent from '../components/tiles.jsx';
import { MdPinIcon64 } from '@miljodirektoratet/md-react';

function PageLeaflet() {
  return (
    <div className="tiles-container">
      <TilesComponent 
        heading="Leaflet Example 1" 
        icon={<MdPinIcon64 height={64} width={64} />} 
        href="#" /* Specify the target URL */
        mode="small" /* Change the size of the tile */
      />
    </div>
  );
}

export default PageLeaflet;